// @ts-strict-ignore
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter, forwardRef,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMFormComponent } from '@form/lm-form.component';

@Component({
  selector: 'lm-list-search-form-dialog',
  standalone: false,
  template: `
    <lm-form
        #LMFormComponent
        [formSpec]="formSpec"
        [formOptions]="formOptions"
        (searchButtonClicked)="onSearchButtonClicked()"
    ></lm-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LMRouteComponentService]
})
export class LMListSearchFormDialogComponent implements AfterViewInit {

  @Input() formSpec: LMFormSpec;
  @Input() set initDataView(dataView: LMDataView) {
    this._initDataView = dataView;
  };

  get initDataView(): LMDataView {
    return this._initDataView;
  }

  @Input() formOptions: LMFormOptions;

  @Output() searchButtonClicked = new EventEmitter<LMFilterEvent>();

  @ViewChild(forwardRef(() => 'LMFormComponent'), { static: true }) lmFormComponent; //: LMFormComponent;

  private _initDataView;

  ngAfterViewInit() {
    this.lmFormComponent.initDataView = this.initDataView;
  }

  onSearchButtonClicked() {
    this.lmFormComponent.searchButtonClicked.subscribe( event => {
      this.searchButtonClicked.emit(event);
    });
  }
}
